import { render, staticRenderFns } from "./customFieldExerciseTypes.vue?vue&type=template&id=8d622f42&scoped=true"
import script from "./customFieldExerciseTypes.vue?vue&type=script&lang=js"
export * from "./customFieldExerciseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d622f42",
  null
  
)

export default component.exports